import ApplePayLogo from 'components/icons/ApplePayLogo';

const ApplePay = () => {
  return (
    <span className="inline-flex items-center">
      <span>Sign up with</span>
      <ApplePayLogo className="ml-1 h-7" />
    </span>
  );
};

export default ApplePay;
